'use client';

import { isDevelopmentEnv } from '@bts-web/utils-functions';

// needed because BE hardcoded the deep link to the staging / production URL, and it removes us from context and we need to return to the current domain, for faster testing
export const processDeepLink = (deepLink: string | undefined) => {
  const isDevelopment = isDevelopmentEnv();

  const isVercelPreviewEnv = window.location.origin.includes('vercel.app');

  const executeDeepLinkProcessing = isDevelopment || isVercelPreviewEnv;

  if (!executeDeepLinkProcessing || !deepLink) {
    return deepLink;
  }

  try {
    // Parse the received deep link URL
    const deepLinkUrl = new URL(deepLink);

    // Get the current domain (window.location.origin includes protocol + domain + port)
    const currentOrigin = window.location.origin;

    // Replace the origin (protocol + domain + port) with current one
    // Keep the pathname, search params, and hash
    const processedUrl = new URL(
      deepLinkUrl.pathname + deepLinkUrl.search + deepLinkUrl.hash,
      currentOrigin,
    );

    return processedUrl.toString();
  } catch (error) {
    // If URL parsing fails, return the original deep link
    console.warn('Failed to process deep link:', error);

    return deepLink;
  }
};
